export default __webpack_public_path__ + "static/media/closetCav3.557c4ac3.jpg";